// eslint-disable-next-line import/prefer-default-export
export { default as SubmissionSuccess } from './submission-success';
